// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Vys","question":"styles_question__1Zxix","inputVisibleButton":"styles_inputVisibleButton__3DqZ_","note":"styles_note__2zEio"};